import { defineAsyncComponent } from 'vue';

// defineAsyncComponent(() => import('xxx.vue'))

const IconColoredAirplane = defineAsyncComponent(() => import('./Airplane.vue'));
const IconColoredAccount = defineAsyncComponent(() => import('./Account.vue'));
const IconColoredAccountHome = defineAsyncComponent(() => import('./AccountHome.vue'));
const IconColoredAdd = defineAsyncComponent(() => import('./Add.vue'));
const IconColoredAdRequest = defineAsyncComponent(() => import('./AdRequest.vue'));
const IconColoredAdServer = defineAsyncComponent(() => import('./AdServer.vue'));
const IconColoredAdSpend = defineAsyncComponent(() => import('./AdSpend.vue'));
const IconColoredAdvancedReport = defineAsyncComponent(() => import('./AdvancedReport.vue'));
const IconColoredAdvertiser = defineAsyncComponent(() => import('./Advertiser.vue'));
const IconColoredAfter = defineAsyncComponent(() => import('./After.vue'));
const IconColoredAirTravel = defineAsyncComponent(() => import('./AirTravel.vue'));
const IconColoredAllGenders = defineAsyncComponent(() => import('./AllGenders.vue'));
const IconColoredApplyAll = defineAsyncComponent(() => import('./ApplyAll.vue'));
const IconColoredApproved = defineAsyncComponent(() => import('./Approved.vue'));
const IconColoredArrival = defineAsyncComponent(() => import('./Arrival.vue'));

const IconColoredArrowUp = defineAsyncComponent(() => import('./ArrowUp.vue'));
const IconColoredArrowDown = defineAsyncComponent(() => import('./ArrowDown.vue'));
const IconColoredArrowRight = defineAsyncComponent(() => import('./ArrowRight.vue'));
const IconColoredAuction = defineAsyncComponent(() => import('./Auction.vue'));
const IconColoredAudienceFile = defineAsyncComponent(() => import('./AudienceFile.vue'));
const IconColoredAudienceGeofenceGroup = defineAsyncComponent(() => import('./AudienceGeofenceGroup.vue'));
const IconColoredAudienceLogic = defineAsyncComponent(() => import('./AudienceLogic.vue'));
const IconColoredAudienceRule = defineAsyncComponent(() => import('./AudienceRule.vue'));
const IconColoredAudienceAudit = defineAsyncComponent(() => import('./AudienceAudit.vue'));
const IconColoredAudit = defineAsyncComponent(() => import('./Audit.vue'));
// const IconColoredAutopilot = defineAsyncComponent(() => import('./Autopilot.vue'));
const IconColoredAvails = defineAsyncComponent(() => import('./Avails.vue'));
// const IconColoredBefore = defineAsyncComponent(() => import('./Before.vue'));
const IconColoredBidAccepted = defineAsyncComponent(() => import('./BidAccepted.vue'));
const IconColoredBiddingStats = defineAsyncComponent(() => import('./BiddingStats.vue'));
const IconColoredBidFailure = defineAsyncComponent(() => import('./BidFailure.vue'));
const IconColoredBidNone = defineAsyncComponent(() => import('./BidNone.vue'));
const IconColoredBidRequest = defineAsyncComponent(() => import('./BidRequest.vue'));
const IconColoredBinocular = defineAsyncComponent(() => import('./Binocular.vue'));
const IconColoredBudget = defineAsyncComponent(() => import('./Budget.vue'));
const IconColoredBudgetBreakdown = defineAsyncComponent(() => import('./BudgetBreakdown.vue'));
const IconColoredBudgetCap = defineAsyncComponent(() => import('./BudgetCap.vue'));
// const IconColoredBuilding = defineAsyncComponent(() => import('./Building.vue'));
const IconColoredBuildings = defineAsyncComponent(() => import('./Buildings.vue'));
// const IconColoredBuy = defineAsyncComponent(() => import('./Buy.vue'));
const IconColoredBuyer = defineAsyncComponent(() => import('./Buyer.vue'));
const IconColoredBuyingStrategy = defineAsyncComponent(() => import('./BuyingStrategy.vue'));
const IconColoredBuyingStrategyFixed = defineAsyncComponent(() => import('./BuyingStrategyFixed.vue'));
const IconColoredCalendar = defineAsyncComponent(() => import('./Calendar.vue'));
const IconColoredCadenceBuy = defineAsyncComponent(() => import('./CadenceBuy.vue'));
// const IconColoredCart = defineAsyncComponent(() => import('./Cart.vue'));
const IconColoredCampaign = defineAsyncComponent(() => import('./Campaign.vue'));
const IconColoredCancelled = defineAsyncComponent(() => import('./Cancelled.vue'));
const IconColoredChart = defineAsyncComponent(() => import('./Chart.vue'));
// const IconColoredChoose = defineAsyncComponent(() => import('./Choose.vue'));
const IconColoredCity = defineAsyncComponent(() => import('./City.vue'));
const IconColoredClock = defineAsyncComponent(() => import('./Clock.vue'));
const IconColoredCloudy = defineAsyncComponent(() => import('./Cloudy.vue'));
const IconColoredCo2 = defineAsyncComponent(() => import('./Co2.vue'));
const IconColoredCompanionAd = defineAsyncComponent(() => import('./CompanionAd.vue'));
const IconColoredCompleted = defineAsyncComponent(() => import('./Completed.vue'));
const IconColoredCoordinates = defineAsyncComponent(() => import('./Coordinates.vue'));
const IconColoredCountry = defineAsyncComponent(() => import('./Country.vue'));
const IconColoredCPM = defineAsyncComponent(() => import('./CPM.vue'));
const IconColoredCreative = defineAsyncComponent(() => import('./Creative.vue'));
const IconColoredCreativeFile = defineAsyncComponent(() => import('./CreativeFile.vue'));
const IconColoredCreativeType = defineAsyncComponent(() => import('./CreativeType.vue'));
const IconColoredCurate = defineAsyncComponent(() => import('./Curate.vue'));
const IconColoredCurrency = defineAsyncComponent(() => import('./Currency.vue'));
const IconColoredCustomField = defineAsyncComponent(() => import('./CustomField.vue'));
const IconColoredDashboard = defineAsyncComponent(() => import('./Dashboard.vue'));
const IconColoredDataPoints = defineAsyncComponent(() => import('./DataPoints.vue'));
const IconColoredDailyGoalCap = defineAsyncComponent(() => import('./DailyGoalCap.vue'));
const IconColoredDaypart = defineAsyncComponent(() => import('./Daypart.vue'));
const IconColoredDeal = defineAsyncComponent(() => import('./Deal.vue'));
const IconColoredDealID = defineAsyncComponent(() => import('./DealID.vue'));
const IconColoredDelivery = defineAsyncComponent(() => import('./Delivery.vue'));
const IconColoredDemographic = defineAsyncComponent(() => import('./Demographic.vue'));
const IconColoredDeparture = defineAsyncComponent(() => import('./Departure.vue'));
const IconColoredDetails = defineAsyncComponent(() => import('./Details.vue'));
const IconColoredDiscount = defineAsyncComponent(() => import('./Discount.vue'));
const IconColoredDiscountedAmount = defineAsyncComponent(() => import('./DiscountedAmount.vue'));
const IconColoredDiscountedCPM = defineAsyncComponent(() => import('./DiscountedCPM.vue'));
const IconColoredDisplayAndVideo = defineAsyncComponent(() => import('./DisplayAndVideo.vue'));
const IconColoredDooh = defineAsyncComponent(() => import('./DOOH.vue'));
const IconColoredDownload = defineAsyncComponent(() => import('./Download.vue'));
const IconColoredDraft = defineAsyncComponent(() => import('./Draft.vue'));
const IconColoredDsp = defineAsyncComponent(() => import('./Dsp.vue'));
const IconColoredDuration = defineAsyncComponent(() => import('./Duration.vue'));
const IconColoredEdit = defineAsyncComponent(() => import('./Edit.vue'));
const IconColoredEmail = defineAsyncComponent(() => import('./Email.vue'));
const IconColoredEmailAlert = defineAsyncComponent(() => import('./EmailAlert.vue'));
const IconColoredEstimatedCPM = defineAsyncComponent(() => import('./EstimatedCPM.vue'));
const IconColoredEvent = defineAsyncComponent(() => import('./Event.vue'));
const IconColoredExchange = defineAsyncComponent(() => import('./Exchange.vue'));
const IconColoredExternalCreative = defineAsyncComponent(() => import('./ExternalCreative.vue'));
const IconColoredExternalEvent = defineAsyncComponent(() => import('./ExternalEvent.vue'));
const IconColoredFallbackCreative = defineAsyncComponent(() => import('./FallbackCreative.vue'));
// const IconColoredFemale = defineAsyncComponent(() => import('./Female.vue'));
const IconColoredFees = defineAsyncComponent(() => import('./Fees.vue'));
const IconColoredFilter = defineAsyncComponent(() => import('./Filter.vue'));
const IconColoredFlowChart = defineAsyncComponent(() => import('./FlowChart.vue'));
// const IconColoredFlash = defineAsyncComponent(() => import('./Flash.vue'));
// const IconColoredForecast = defineAsyncComponent(() => import('./Forecast.vue'));
const IconColoredGeneratedReports = defineAsyncComponent(() => import('./GeneratedReports.vue'));
const IconColoredGeofenceGroup = defineAsyncComponent(() => import('./GeofenceGroup.vue'));
const IconColoredGlobe = defineAsyncComponent(() => import('./Globe.vue'));
const IconColoredGoal = defineAsyncComponent(() => import('./Goal.vue'));
const IconColoredGroupUsers = defineAsyncComponent(() => import('./GroupUsers.vue'));
const IconColoredGuaranteed = defineAsyncComponent(() => import('./Guaranteed.vue'));
const IconColoredHeatmap = defineAsyncComponent(() => import('./Heatmap.vue'));
// const IconColoredHierarchy = defineAsyncComponent(() => import('./Pie.vue'));
const IconColoredYieldManager = defineAsyncComponent(() => import('./YieldManager.vue'));
const IconColoredHide = defineAsyncComponent(() => import('./Hide.vue'));
const IconColoredHigh = defineAsyncComponent(() => import('./High.vue'));
const IconColoredHighIncome = defineAsyncComponent(() => import('./HighIncome.vue'));
const IconColoredHtml = defineAsyncComponent(() => import('./Html.vue'));
const IconColoredIab = defineAsyncComponent(() => import('./Iab.vue'));
const IconColoredImage = defineAsyncComponent(() => import('./Image.vue'));
const IconColoredImportedAudiences = defineAsyncComponent(() => import('./ImportedAudiences.vue'));
const IconColoredImpression = defineAsyncComponent(() => import('./Impression.vue'));
const IconColoredImpressionsDelivered = defineAsyncComponent(() => import('./ImpressionsDelivered.vue'));
const IconColoredInfinity = defineAsyncComponent(() => import('./Infinity.vue'));
const IconColoredInfo = defineAsyncComponent(() => import('./Info.vue'));
const IconColoredInventory = defineAsyncComponent(() => import('./Inventory.vue'));
const IconColoredJourney = defineAsyncComponent(() => import('./Journey.vue'));
const IconColoredLanguage = defineAsyncComponent(() => import('./Language.vue'));
const IconColoredLeaf = defineAsyncComponent(() => import('./Leaf.vue'));
const IconColoredLegacy = defineAsyncComponent(() => import('./Legacy.vue'));
const IconColoredLift = defineAsyncComponent(() => import('./Lift.vue'));
const IconColoredLiftDashboard = defineAsyncComponent(() => import('./LiftDashboard.vue'));
const IconColoredLightBulb = defineAsyncComponent(() => import('./LightBulb.vue'));
const IconColoredLineItem = defineAsyncComponent(() => import('./LineItem.vue'));
const IconColoredLink = defineAsyncComponent(() => import('./Link.vue'));
const IconColoredLive = defineAsyncComponent(() => import('./Live.vue'));
const IconColoredLocation = defineAsyncComponent(() => import('./Location.vue'));
const IconColoredLocation2 = defineAsyncComponent(() => import('./Location2.vue'));
// const IconColoredLow = defineAsyncComponent(() => import('./Low.vue'));
const IconColoredLowIncome = defineAsyncComponent(() => import('./LowIncome.vue'));
const IconColoredMale = defineAsyncComponent(() => import('./Male.vue'));
const IconColoredMap = defineAsyncComponent(() => import('./Map.vue'));
const IconColoredMargin = defineAsyncComponent(() => import('./Margin.vue'));
const IconColoredMarket = defineAsyncComponent(() => import('./Market.vue'));
const IconColoredMarketplace = defineAsyncComponent(() => import('./Marketplace.vue'));
const IconColoredMarkup = defineAsyncComponent(() => import('./Markup.vue'));
// const IconColoredMaster = defineAsyncComponent(() => import('./Master.vue'));
const IconColoredMaxBidCpm = defineAsyncComponent(() => import('./MaxBidCpm.vue'));
const IconColoredMediaOwner = defineAsyncComponent(() => import('./MediaOwner.vue'));
const IconColoredMediaType = defineAsyncComponent(() => import('./MediaType.vue'));
const IconColoredMinus = defineAsyncComponent(() => import('./Minus.vue'));
const IconColoredMissingDimension = defineAsyncComponent(() => import('./MissingDimension.vue'));
const IconColoredMobilePhone = defineAsyncComponent(() => import('./MobilePhone.vue'));
const IconColoredMobilePhoneVibrating = defineAsyncComponent(() => import('./MobilePhoneVibrating.vue'));
const IconColoredMonitoring = defineAsyncComponent(() => import('./Monitoring.vue'));
const IconColoredMovie = defineAsyncComponent(() => import('./Movie.vue'));
const IconColoredNetwork = defineAsyncComponent(() => import('./Network.vue'));
const IconColoredNew = defineAsyncComponent(() => import('./New.vue'));
const IconColoredNo = defineAsyncComponent(() => import('./No.vue'));
const IconColoredNotes = defineAsyncComponent(() => import('./Notes.vue'));
const IconColoredOpenExchange = defineAsyncComponent(() => import('./OpenExchange.vue'));
const IconColoredOperatingHours = defineAsyncComponent(() => import('./OperatingHours.vue'));
const IconColoredOrientationLandscape = defineAsyncComponent(() => import('./OrientationLandscape.vue'));
const IconColoredOrientationPortrait = defineAsyncComponent(() => import('./OrientationPortrait.vue'));
const IconColoredPacing = defineAsyncComponent(() => import('./Pacing.vue'));
const IconColoredPacingStrategyAhead = defineAsyncComponent(() => import('./PacingStrategyAhead.vue'));
const IconColoredPacingStrategyAsap = defineAsyncComponent(() => import('./PacingStrategyAsap.vue'));
const IconColoredPacingStrategyEven = defineAsyncComponent(() => import('./PacingStrategyEven.vue'));
const IconColoredPacingStrategyOptimized = defineAsyncComponent(() => import('./PacingStrategyOptimized.vue'));
const IconColoredPacingStrategyOptimized2 = defineAsyncComponent(() => import('./PacingStrategyOptimized2.vue'));
const IconColoredPartiallyApproved = defineAsyncComponent(() => import('./PartiallyApproved.vue'));
const IconColoredPartiallyRejected = defineAsyncComponent(() => import('./PartiallyRejected.vue'));
const IconColoredPause = defineAsyncComponent(() => import('./Pause.vue'));
const IconColoredPendingApproval = defineAsyncComponent(() => import('./PendingApproval.vue'));
const IconColoredPin2 = defineAsyncComponent(() => import('./Pin2.vue'));
const IconColoredPlan = defineAsyncComponent(() => import('./Plan.vue'));
const IconColoredPlane = defineAsyncComponent(() => import('./Plane.vue'));
const IconColoredPlay = defineAsyncComponent(() => import('./Play.vue'));
const IconColoredPlayback = defineAsyncComponent(() => import('./Playback.vue'));
const IconColoredPlayHexagon = defineAsyncComponent(() => import('./PlayHexagon.vue'));
const IconColoredPlus = defineAsyncComponent(() => import('./Plus.vue'));
const IconColoredPollen = defineAsyncComponent(() => import('./Pollen.vue'));
const IconColoredPollenHigh = defineAsyncComponent(() => import('./PollenHigh.vue'));
const IconColoredPollenHigh2 = defineAsyncComponent(() => import('./PollenHigh2.vue'));
// const IconColoredPollenLow = defineAsyncComponent(() => import('./PollenLow.vue'));
const IconColoredPollenLow2 = defineAsyncComponent(() => import('./PollenLow2.vue'));
const IconColoredPollenMedium = defineAsyncComponent(() => import('./PollenMedium.vue'));
const IconColoredPollenMedium2 = defineAsyncComponent(() => import('./PollenMedium2.vue'));
const IconColoredPollenNone = defineAsyncComponent(() => import('./PollenNone.vue'));
const IconColoredPollenVeryHigh = defineAsyncComponent(() => import('./PollenVeryHigh.vue'));
const IconColoredPollenVeryLow = defineAsyncComponent(() => import('./PollenVeryLow.vue'));
const IconColoredPostalCode = defineAsyncComponent(() => import('./PostalCode.vue'));
const IconColoredPreferred = defineAsyncComponent(() => import('./Preferred.vue'));
const IconColoredPrivate = defineAsyncComponent(() => import('./Private.vue'));
const IconColoredPrivateDeal = defineAsyncComponent(() => import('./PrivateDeal.vue'));
const IconColoredProgress = defineAsyncComponent(() => import('./Progress.vue'));
const IconColoredProperty = defineAsyncComponent(() => import('./Property.vue'));
const IconColoredPublished = defineAsyncComponent(() => import('./Published.vue'));
const IconColoredPurchaseType = defineAsyncComponent(() => import('./PurchaseType.vue'));
const IconColoredRadius = defineAsyncComponent(() => import('./Radius.vue'));
const IconColoredRaining = defineAsyncComponent(() => import('./Raining.vue'));
const IconColoredReachAndFrequency = defineAsyncComponent(() => import('./ReachAndFrequency.vue'));
const IconColoredRegion = defineAsyncComponent(() => import('./Region.vue'));
const IconColoredRejected = defineAsyncComponent(() => import('./Rejected.vue'));
const IconColoredReport = defineAsyncComponent(() => import('./Report.vue'));
const IconColoredReportBreakdown = defineAsyncComponent(() => import('./ReportBreakdown.vue'));
const IconColoredReportDimension = defineAsyncComponent(() => import('./ReportDimension.vue'));
const IconColoredReportFormat = defineAsyncComponent(() => import('./ReportFormat.vue'));
const IconColoredReportMetric = defineAsyncComponent(() => import('./ReportMetric.vue'));
const IconColoredRetired = defineAsyncComponent(() => import('./Retired.vue'));
const IconColoredRevenue = defineAsyncComponent(() => import('./Revenue.vue'));
const IconColoredRiskAverse = defineAsyncComponent(() => import('./RiskAverse.vue'));
const IconColoredRiskSeeking = defineAsyncComponent(() => import('./RiskSeeking.vue'));
const IconColoredRunning = defineAsyncComponent(() => import('./Running.vue'));
const IconColoredSad = defineAsyncComponent(() => import('./Sad.vue'));
const IconColoredScreen = defineAsyncComponent(() => import('./Screen.vue'));
const IconColoredScreenSize = defineAsyncComponent(() => import('./ScreenSize.vue'));
const IconColoredSearch = defineAsyncComponent(() => import('./Search.vue'));
const IconColoredSettings = defineAsyncComponent(() => import('./Settings.vue'));
const IconColoredShare = defineAsyncComponent(() => import('./Share.vue'));
const IconColoredSite = defineAsyncComponent(() => import('./Site.vue'));
const IconColoredSnowing = defineAsyncComponent(() => import('./Snowing.vue'));
const IconColoredSSP = defineAsyncComponent(() => import('./SSP.vue'));
const IconColoredStats = defineAsyncComponent(() => import('./Stats.vue'));
const IconColoredStroreFront = defineAsyncComponent(() => import('./StoreFront.vue'));
const IconColoredSummary = defineAsyncComponent(() => import('./Summary.vue'));
const IconColoredSunny = defineAsyncComponent(() => import('./Sunny.vue'));
const IconColoredTag = defineAsyncComponent(() => import('./Tag.vue'));
const IconColoredTargeting = defineAsyncComponent(() => import('./Targeting.vue'));
const IconColoredTeenager = defineAsyncComponent(() => import('./Teenager.vue'));
const IconColoredTempHigh = defineAsyncComponent(() => import('./TempHigh.vue'));
const IconColoredTempLow = defineAsyncComponent(() => import('./TempLow.vue'));
const IconColoredTimezone = defineAsyncComponent(() => import('./Timezone.vue'));
const IconColoredTracking = defineAsyncComponent(() => import('./Tracking.vue'));
const IconColoredTravelDestination = defineAsyncComponent(() => import('./TravelDestination.vue'));
const IconColoredTrueBid = defineAsyncComponent(() => import('./TrueBid.vue'));
// const IconColoredUnguaranteed = defineAsyncComponent(() => import('./Unguaranteed.vue'));
const IconColoredUnit = defineAsyncComponent(() => import('./Unit.vue'));
const IconColoredUnitPack = defineAsyncComponent(() => import('./UnitPack.vue'));
const IconColoredUpcoming = defineAsyncComponent(() => import('./Upcoming.vue'));
const IconColoredUser = defineAsyncComponent(() => import('./User.vue'));
// const IconColoredUv = defineAsyncComponent(() => import('./UV.vue'));
const IconColoredVastTag = defineAsyncComponent(() => import('./VastTag.vue'));
const IconColoredVideo = defineAsyncComponent(() => import('./Video.vue'));
const IconColoredVisualization = defineAsyncComponent(() => import('./Visualization.vue'));
const IconColoredWait = defineAsyncComponent(() => import('./Wait.vue'));
const IconColoredWalkIn = defineAsyncComponent(() => import('./WalkIn.vue'));
const IconColoredWarning = defineAsyncComponent(() => import('./Warning.vue'));
// const IconColoredWarningHexagon = defineAsyncComponent(() => import('./WarningHexagon.vue'));
const IconColoredWeather = defineAsyncComponent(() => import('./Weather.vue'));
// const IconColoredWin = defineAsyncComponent(() => import('./Win.vue'));
const IconColoredZip = defineAsyncComponent(() => import('./Zip.vue'));
const IconColoredAudio = defineAsyncComponent(() => import('./Audio.vue'));
const IconColoredView = defineAsyncComponent(() => import('./View.vue'));
const IconColoredBoatWheel = defineAsyncComponent(() => import('./BoatWheel.vue'));

export {
  IconColoredAccount,
  IconColoredAccountHome,
  IconColoredAdd,
  IconColoredAdRequest,
  IconColoredAdServer,
  IconColoredAdSpend,
  IconColoredAdvancedReport,
  IconColoredAdvertiser,
  IconColoredAfter,
  IconColoredAirplane,
  IconColoredAirTravel,
  IconColoredAllGenders,
  IconColoredApplyAll,
  IconColoredApproved,
  IconColoredArrival,
  IconColoredArrowDown,
  IconColoredArrowRight,
  IconColoredArrowUp,
  IconColoredAuction,
  IconColoredAudienceAudit,
  IconColoredAudienceFile,
  IconColoredAudienceGeofenceGroup,
  IconColoredAudienceLogic,
  IconColoredAudienceRule,
  IconColoredAudio,
  IconColoredAudit,
  // IconColoredAutopilot,
  IconColoredAvails,
  // IconColoredBefore,
  IconColoredBidAccepted,
  IconColoredBiddingStats,
  IconColoredBidFailure,
  IconColoredBidNone,
  IconColoredBidRequest,
  IconColoredBinocular,
  IconColoredBoatWheel,
  IconColoredBudget,
  IconColoredBudgetBreakdown,
  IconColoredBudgetCap,
  // IconColoredBuilding,
  IconColoredBuildings,
  // IconColoredBuy,
  IconColoredBuyer,
  IconColoredBuyingStrategy,
  IconColoredBuyingStrategyFixed,
  IconColoredCadenceBuy,
  IconColoredCalendar,
  IconColoredCampaign,
  IconColoredCancelled,
  // IconColoredCart,
  IconColoredChart,
  // IconColoredChoose,
  IconColoredCity,
  IconColoredClock,
  IconColoredCloudy,
  IconColoredCo2,
  IconColoredCompanionAd,
  IconColoredCompleted,
  IconColoredCoordinates,
  IconColoredCountry,
  IconColoredCPM,
  IconColoredCreative,
  IconColoredCreativeFile,
  IconColoredCreativeType,
  IconColoredCurate,
  IconColoredCurrency,
  IconColoredCustomField,
  IconColoredDailyGoalCap,
  IconColoredDashboard,
  IconColoredDataPoints,
  IconColoredDaypart,
  IconColoredDeal,
  IconColoredDealID,
  IconColoredDelivery,
  IconColoredDemographic,
  IconColoredDeparture,
  IconColoredDetails,
  IconColoredDiscount,
  IconColoredDiscountedAmount,
  IconColoredDiscountedCPM,
  IconColoredDisplayAndVideo,
  IconColoredDooh,
  IconColoredDownload,
  IconColoredDraft,
  IconColoredDsp,
  IconColoredDuration,
  IconColoredEdit,
  IconColoredEmail,
  IconColoredEmailAlert,
  IconColoredEstimatedCPM,
  IconColoredEvent,
  IconColoredExchange,
  IconColoredExternalCreative,
  IconColoredExternalEvent,
  IconColoredFallbackCreative,
  IconColoredFees,
  // IconColoredFemale,
  IconColoredFilter,
  IconColoredFlowChart,
  // IconColoredFlash,
  // IconColoredForecast,
  IconColoredGeneratedReports,
  IconColoredGeofenceGroup,
  IconColoredGlobe,
  IconColoredGoal,
  IconColoredGroupUsers,
  IconColoredGuaranteed,
  IconColoredHeatmap,
  IconColoredHide,
  IconColoredHigh,
  IconColoredHighIncome,
  IconColoredHtml,
  IconColoredIab,
  IconColoredImage,
  IconColoredImportedAudiences,
  IconColoredImpression,
  IconColoredImpressionsDelivered,
  IconColoredInfinity,
  IconColoredInfo,
  IconColoredInventory,
  IconColoredJourney,
  IconColoredLanguage,
  IconColoredLeaf,
  IconColoredLegacy,
  IconColoredLift,
  IconColoredLiftDashboard,
  IconColoredLightBulb,
  IconColoredLineItem,
  IconColoredLink,
  IconColoredLive,
  IconColoredLocation,
  IconColoredLocation2,
  // IconColoredLow,
  IconColoredLowIncome,
  IconColoredMale,
  IconColoredMap,
  IconColoredMargin,
  IconColoredMarket,
  IconColoredMarketplace,
  IconColoredMarkup,
  // IconColoredMaster,
  IconColoredMaxBidCpm,
  IconColoredMediaOwner,
  IconColoredMediaType,
  IconColoredMinus,
  IconColoredMissingDimension,
  IconColoredMobilePhone,
  IconColoredMobilePhoneVibrating,
  IconColoredMonitoring,
  IconColoredMovie,
  IconColoredNetwork,
  IconColoredNew,
  IconColoredNo,
  IconColoredNotes,
  IconColoredOpenExchange,
  IconColoredOperatingHours,
  IconColoredOrientationLandscape,
  IconColoredOrientationPortrait,
  IconColoredPacing,
  IconColoredPacingStrategyAhead,
  IconColoredPacingStrategyAsap,
  IconColoredPacingStrategyEven,
  IconColoredPacingStrategyOptimized,
  IconColoredPacingStrategyOptimized2,
  IconColoredPartiallyApproved,
  IconColoredPartiallyRejected,
  IconColoredPause,
  IconColoredPendingApproval,
  IconColoredPin2,
  IconColoredPlan,
  IconColoredPlane,
  IconColoredPlay,
  IconColoredPlayback,
  IconColoredPlayHexagon,
  IconColoredPlus,
  IconColoredPollen,
  IconColoredPollenHigh,
  IconColoredPollenHigh2,
  // IconColoredPollenLow,
  IconColoredPollenLow2,
  IconColoredPollenMedium,
  IconColoredPollenMedium2,
  IconColoredPollenNone,
  IconColoredPollenVeryHigh,
  IconColoredPollenVeryLow,
  IconColoredPostalCode,
  IconColoredPreferred,
  IconColoredPrivate,
  IconColoredPrivateDeal,
  IconColoredProgress,
  IconColoredProperty,
  IconColoredPublished,
  IconColoredPurchaseType,
  IconColoredRadius,
  IconColoredRaining,
  IconColoredReachAndFrequency,
  IconColoredRegion,
  IconColoredRejected,
  IconColoredReport,
  IconColoredReportBreakdown,
  IconColoredReportDimension,
  IconColoredReportFormat,
  IconColoredReportMetric,
  IconColoredRetired,
  IconColoredRevenue,
  IconColoredRiskAverse,
  IconColoredRiskSeeking,
  IconColoredRunning,
  IconColoredSad,
  IconColoredScreen,
  IconColoredScreenSize,
  IconColoredSearch,
  IconColoredSettings,
  IconColoredShare,
  IconColoredSite,
  IconColoredSnowing,
  IconColoredSSP,
  IconColoredStats,
  IconColoredStroreFront,
  IconColoredSummary,
  IconColoredSunny,
  IconColoredTag,
  IconColoredTargeting,
  IconColoredTeenager,
  IconColoredTempHigh,
  IconColoredTempLow,
  IconColoredTimezone,
  IconColoredTracking,
  IconColoredTravelDestination,
  IconColoredTrueBid,
  // IconColoredUnguaranteed,
  IconColoredUnit,
  IconColoredUnitPack,
  IconColoredUpcoming,
  IconColoredUser,
  // IconColoredUv,
  IconColoredVastTag,
  IconColoredVideo,
  IconColoredView,
  IconColoredVisualization,
  IconColoredWait,
  IconColoredWalkIn,
  IconColoredWarning,
  // IconColoredWarningHexagon,
  IconColoredWeather,
  // IconColoredHierarchy,
  IconColoredYieldManager,
  // IconColoredWin,
  IconColoredZip,
};

export default {};
